export default "__VITE_ASSET__sWzLxffX__"